import CircularProgress from '@mui/material/CircularProgress';
import Icon from '@mui/material/Icon';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import useTheme from '@mui/material/styles/useTheme';
import useDynamicFingoLogo from '../../hooks/useDynamicFingoLogo';

const FingoCircularProgressLoader = ({
  logo,
  showEmptyLogo,
}) => {
  const theme = useTheme();
  const logoToUse = showEmptyLogo ? '' : (logo || useDynamicFingoLogo());

  return (
    <Stack alignItems="center" justifyContent="center" height="80%" textAlign="center">
      <svg>
        <linearGradient id="linearColors" x1="0" y1="0" x2="1" y2="1">
          <stop offset="20%" stopColor={theme.palette.transition.A600} />
          <stop offset="90%" stopColor="#F7F7F7" />
        </linearGradient>
      </svg>
      <CircularProgress
        size={60}
        sx={{ circle: { stroke: 'url(#linearColors)' } }}
      />
      <Typography pt={2} variant="body2" fontWeight="500">LA LIQUIDEZ QUE NECESITAS HOY</Typography>
      {!!logoToUse && (
        <Icon sx={{ width: 150, height: 'auto', mt: 2 }}>
          <img src={logoToUse} style={{ height: '100%', width: '100%' }} alt="fingo-logo" />
        </Icon>
      )}
    </Stack>
  );
};

FingoCircularProgressLoader.propTypes = {
  logo: PropTypes.string,
  showEmptyLogo: PropTypes.bool,
};

FingoCircularProgressLoader.defaultProps = {
  logo: '',
  showEmptyLogo: false,
};

export default FingoCircularProgressLoader;
